(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rr-bag-capacity"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const summary = event.target.closest('.rr-capacity-filter > summary');
  if (!summary) {
    const link = event.target.closest('.rr-capacity-filter a');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const destination = new URL(link.href);
    destination.search = window.location.search;
    destination.searchParams.delete('page');
    destination.searchParams.delete('section_id');
    window.location.assign(destination.href);
    return;
  }
  event.preventDefault();
  event.stopImmediatePropagation();
  const panel = summary.parentElement;
  panel.open = !panel.open;
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-chat-stationary"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('rr-chat-link-template');
  if (!template) return;
  let trigger = null;
  const observedRoots = new WeakSet();
  let returnTarget = null;
  let wasOpen = false;
  let queued = false;
  const makeLink = (className) => {
    const link = template.content.firstElementChild.cloneNode(true);
    link.className = className;
    return link;
  };
  const addLinks = () => {
    document.querySelectorAll('.desktop-main-menu > ul > li > a[href$="/pages/chi-siamo"]').forEach(anchor => {
      const list = anchor.closest('ul');
      if (list && !list.querySelector('[data-rr-open-chat]')) {
        const item = document.createElement('li');
        item.className = 'list-menu--hover';
        item.append(makeLink(anchor.className));
        anchor.closest('li').after(item);
      }
    });
    document.querySelectorAll('.menu-drawer__navigation > ul').forEach(list => {
      if (!list.querySelector(':scope > li > [data-rr-open-chat]')) {
        const item = document.createElement('li');
        item.append(makeLink('menu-drawer__menu-item h4 menu-drawer__menu-item__main'));
        const storeLink = list.querySelector('a[href$="/pages/chi-siamo"]');
        const storeItem = storeLink?.closest('li');
        if (storeItem?.parentElement === list) storeItem.after(item);
        else list.append(item);
      }
    });
    document.querySelectorAll('footer .rr-store-location').forEach(container => {
      if (!container.querySelector('[data-rr-open-chat]')) container.append(makeLink('rr-chat-footer-link'));
    });
  };
  const sync = () => {
    queued = false;
    addLinks();
    const host = document.querySelector('shopify-chat');
    const shellRoot = host?.shadowRoot;
    const root = shellRoot?.querySelector('shopify-agent-runtime')?.shadowRoot || shellRoot;
    trigger = root?.querySelector('button[part~="activator"]') || null;
    const ready = !!trigger && !!document.querySelector('footer [data-rr-open-chat]') && !!document.querySelector('.menu-drawer__navigation [data-rr-open-chat]');
    document.documentElement.classList.toggle('rr-chat-stationary', ready);
    [shellRoot, root].forEach(current => {
      if (current && !observedRoots.has(current)) {
        observedRoots.add(current);
        new MutationObserver(schedule).observe(current, {childList:true, subtree:true, attributes:true, attributeFilter:['aria-expanded']});
      }
    });
    if (!trigger) return;
    const open = trigger?.getAttribute('aria-expanded') === 'true';
    if (wasOpen && !open && returnTarget?.isConnected) {
      const target = returnTarget;
      if (target.closest('menu-drawer')) {
        document.querySelector('.menu-drawer > menu-drawer > details > summary')?.focus();
      } else target.focus({preventScroll:true});
      returnTarget = null;
    }
    wasOpen = open;
  };
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-rr-open-chat]');
    if (!link || !trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    returnTarget = link;
    const drawer = link.closest('menu-drawer');
    const launch = () => {
      if (trigger?.getAttribute('aria-expanded') !== 'true') trigger?.click();
    };
    if (drawer?.querySelector('details[open]')) {
      drawer.querySelector('.popup-modal__toggle')?.click();
      setTimeout(launch, 350);
    } else launch();
  });
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  sync();
  let tries = 0;
  const timer = setInterval(() => {
    sync();
    if (trigger || ++tries >= 60) clearInterval(timer);
  }, 500);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rr-language-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  document.querySelectorAll('.rr-language-dropdown[open]').forEach(function(menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.rr-language-dropdown[open]').forEach(function(menu) {
    menu.open = false;
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
